import { useEffect, useState } from 'react'
import { trackThemeChanged } from '../analytics/track'
import {
  applyWebsiteTheme,
  bootWebsiteTheme,
  type WebsiteTheme,
} from './website-theme'

export function WebsiteThemeToggle() {
  const [theme, setTheme] = useState<WebsiteTheme>(() => bootWebsiteTheme())

  useEffect(() => {
    applyWebsiteTheme(theme)
  }, [theme])

  const next: WebsiteTheme = theme === 'light' ? 'dark' : 'light'

  return (
    <button
      type="button"
      className="wt-theme-toggle"
      onClick={() => {
        setTheme(next)
        trackThemeChanged(next)
      }}
      aria-label={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
      title={theme === 'light' ? 'Dark theme' : 'Light theme'}
    >
      {theme === 'light' ? (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M21 14.5A8.5 8.5 0 1 1 9.5 3 7 7 0 0 0 21 14.5Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8" />
          <path
            d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.2 5.2l1.6 1.6M17.2 17.2l1.6 1.6M18.8 5.2l-1.6 1.6M6.8 17.2l-1.6 1.6"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      )}
    </button>
  )
}
